





































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { Base } from '@/components/common/base';
import { Utils } from '@/helper/utils';
import { IDialogOption } from '@/models/dialog';
import { getVehicleReviveSettingHeaders } from '@/views/admin/vehiclerevivesettings/vehicleReviveSettings';
import { vehicleReviveSettingsService } from '@/shared';
import { VehicleReviveSettings, VehicleReviveSettingsJson } from '@/models/inventory/vehiclerevivesettings';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
    components: {
        Stores: () => import('@/components/common/store.select.vue'),
        AppGrid: () => import('@/components/common/app.grid.vue'),
        AppDialog: () => import('@/components/common/app.dialog.vue'),
    },
})
export default class VehicleReviveSettingsListPage extends Base {
    public headers: VHeaders[] = getVehicleReviveSettingHeaders(this);
    public pagedVehicleReviveSettings: VehicleReviveSettings[] = [];
    public vehicleReviveSettingsJson: VehicleReviveSettingsJson[] = [];
    public storeId: number = 0;

    public pagination = new PaginationModel('settingType');
    public loading: boolean = false;
    public actions: any[] = [];
    public deleteDialog: IDialogOption = {
        width: 400,
        title: this.$parent.$t('vehicleReviveSettings.deleteDialogTitle') as string,
        model: false,
        action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
        loading: false,
        onAction: (): void => {
            this.deleteVehicleReviveSettings();
        },
    };
    public VehicleReviveSettingsIdToDelete: number = 0;
    public items: any[] = [{ key: '0', value: 'New' }, { key: '1', value: 'Used' }]; // [ 'New', 'Used' ]
    public vehicleType: string = '';

    public searched: boolean = false;
    public deleted: boolean = false;

    public flags = {
        loading: false,
    };
    public id: number = 0;
    public settingsId: string = '';
    public created() {
        this.storeId = Number(this.$route.params.storeId) ?
            Number(this.$route.params.storeId) : this.userSession.storeId;
        this.vehicleType = this.$route.params.vehicleType ? this.$route.params.vehicleType : '0';
    }

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'addVehicleReviveSettings') {
            if (!this.storeId || !this.vehicleType) {
                this.showAlert(false,  this.$t('vehicleReviveSettings.alertSelectStoreAndVehicleType'));
                this.resetMethodName(methodName);
                return;
            }
            this.vehicleReviveSettingsAdd();
        }
        this.resetMethodName(methodName);
    }
    public resetMethodName(methodName): void {
        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({ id: '0', type: 'button', title: this.$t('vehicleReviveSettings.btnAddVehicleReviveSetting'), disabled: false, visible: true, class: 'btn', label: this.$t('vehicleReviveSettings.btnAddVehicleReviveSetting'), click: 'addVehicleReviveSettings', icon: 'fas fa-plus-circle' });
        this.$emit('updateToolBar', buttons);
    }
    public mounted() {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'vehicleReviveSettings');

        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });
        if (!this.checkUserRole(['SuperAdmin', 'T-Admin', 'E-Admin'])) {
            this.getVehicleReviveSettings();
        }

        this.actions = [
            {
                type: 'link',
                icon: 'fas fa-edit',
                title:  this.$t('vehicleReviveSettings.reviveSettingsGridHeaders.gridAction.edit') as string,
                action: (model: VehicleReviveSettingsJson) => {
                    return {
                        name: 'admin.vehiclerevivesettings.edit',
                        params: {
                            id: this.id,
                            storeId: this.storeId,
                            vehicleType: this.vehicleType,
                            settingsId: model.settingsId,
                        },
                    };
                },
            }
            , {
                type: 'button',
                icon: 'fas fa-trash-alt',
                title: this.$t('vehicleReviveSettings.reviveSettingsGridHeaders.gridAction.delete') as string,
                color: 'error',
                action: (model: VehicleReviveSettingsJson) => {
                    this.confirmDelete(this.id, model.settingsId);
                },
            }];
    }

    public async getVehicleReviveSettings(): Promise<void> {
        this.storeId = this.storeId !== 0 ? this.storeId : Number(this.$route.params.storeId);
        try {
            this.flags.loading = true;
            const resp = await vehicleReviveSettingsService.getVehicleReviveSettings(Number(this.storeId));
            if (resp) {
                this.pagedVehicleReviveSettings = resp.results;
                if (this.pagedVehicleReviveSettings.length > 0) {
                    this.id = this.pagedVehicleReviveSettings[0].id;
                    this.vehicleReviveSettingsJson = this.pagedVehicleReviveSettings[0].vehicleReviveSettingsJson;

                    this.settingsId = this.vehicleReviveSettingsJson[0].settingsId;
                } else {
                    this.id = 0;
                    this.vehicleReviveSettingsJson = [];
                    this.settingsId = '';
                }
                this.filterByVehicleType(this.vehicleType);
            }
        } finally {
            this.flags.loading = false;
        }
    }

    public updatePaging(paging: any) {
        this.pagination = paging;
    }

    public confirmDelete(id: number, settingsId: string): void {
        this.deleteDialog.model = true;
        this.VehicleReviveSettingsIdToDelete = id;
        this.settingsId = settingsId;
    }

    public async deleteVehicleReviveSettings(): Promise<void> {
        try {
            this.deleteDialog.loading = true;
            await vehicleReviveSettingsService
                .deleteVehicleReviveSettings(this.VehicleReviveSettingsIdToDelete, this.storeId, this.settingsId);
            this.deleteDialog.model = false;
            this.deleted = true;
            this.showAlert(true, this.$t('vehicleReviveSettings.alertDeleteVehicleReviveSetting'));
            this.getVehicleReviveSettings();
        } finally {
            this.deleteDialog.model = false;
            this.deleteDialog.loading = false;
        }
    }

    public filterByVehicleType(selectedVehicleType): void {
        if (this.pagedVehicleReviveSettings.length > 0) {
            this.vehicleReviveSettingsJson = this.pagedVehicleReviveSettings[0]
                .vehicleReviveSettingsJson.filter((m) => {
                    return m.vehicleType === (selectedVehicleType === '0' ? 'New' : 'Used');
                });
            this.pagination.totalItems = this.vehicleReviveSettingsJson.length;
        }
    }

    public updateStore(storeId: number): void {
        this.storeId = storeId;
        this.getVehicleReviveSettings();
    }
    public checkUserRole(routeRoles: string[]): boolean {
        return this.isAuthorizedToAccess(routeRoles);
    }

    public vehicleReviveSettingsAdd(): void {
        this.$router.push({
            name: 'admin.vehiclerevivesettings.add',
            params: {
                id: this.id ? this.id.toString() : '0',
                storeId: this.storeId.toString(),
                vehicleType: this.vehicleType.toString(),
                settingsId: '0',
            },
        });
    }
}
